export const MODULE_STATUS = {
  INCOMPLETED: 'INCOMPLETED',
  // Video watched but not yet past the 50% threshold (◐).
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const MODULE_STATUS_TH = {
  INCOMPLETED: 'เข้าเรียนไม่ครบ',
  IN_PROGRESS: 'เข้าเรียนแล้ว',
  COMPLETED: 'เข้าเรียนครบ',
};

export const QUIZ_MODULE_STATUS_TH = {
  INCOMPLETED: 'เข้าสอบไม่ครบ',
  COMPLETED: 'เข้าสอบครบ',
};

export const MODULE_PROGRESS_STATUS = {
  INCOMPLETED: 'INCOMPLETED',
  COMPLETED: 'COMPLETED',
};

export const PRACQUIZ_STATUS = {
  INCOMPLETED: 'INCOMPLETED',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
};

export const HOMEWORK_STATUS = {
  INCOMPLETED: 'INCOMPLETED',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
};

export const MODULE_TYPE = {
  LESSON: 'LESSON',
  PRACQUIZ: 'PRACQUIZ',
};

export const CONTENT_TYPE = {
  VDO: 'VDO',
  QUIZ: 'QUIZ',
};

export const RAW_CONTENT_TYPE = {
  VDO: 'Video',
  QUIZ: 'Quiz',
  QUIZ_FEED: 'QuizFeed',
};

export const RANK_STATUS = {
  GOOD: 'GOOD',
  NORMAL: 'NORMAL',
  NEED_IMPROVEMENT: 'NEED_IMPROVEMENT',
  UNRANK: 'UNRANK',
};

export const RANK_STATUS_TH = {
  UNRANK: 'รอผลการสอบ',
  NEED_IMPROVEMENT: 'ควรปรับปรุง',
  NORMAL: 'พอใช้',
  GOOD: 'ดี',
};

// Used by the Excel exports, which have no ◐ icon to tell IN_PROGRESS apart from
// COMPLETED on sight — give it distinct text here (the web UI badge still just
// says "เข้าเรียนแล้ว" since the icon already disambiguates it there).
export const SINGLE_MODULE_STATUS_TH = {
  INCOMPLETED: 'ยังไม่เข้าเรียน',
  IN_PROGRESS: 'เข้าเรียนแล้ว แต่ยังไม่ถึงเกณฑ์',
  COMPLETED: 'เข้าเรียนแล้ว',
};

// % of a video watched, formatted for display/export. null/undefined (no
// timespent data, e.g. quiz rows) renders as '-' rather than a blank cell.
export const formatWatchedPercent = value => {
  if (value === null || value === undefined) return '-';
  return `${value}%`;
};
